export { default as createReCaptchaComponent } from "./createReCaptchaComponent";
export { default as createTermsOfServiceComponent } from "./createTermsOfServiceComponent";
